export const STATDB_NAME = 'Verksamhetssystem'
export const KOLADA_NAME = 'Offentliga data'
export const NO_COMPARISON = 'Ingen jämförelse'
